import cx from 'classnames';
import { createPropInlineStyle } from '../../utils';
import styles from './index.module.css';
/**
 * @typedef {"full" | "auto" | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | String} width
 *
 * @param width {width}
 * @returns - [className, style]
 *
 * @example
 * const [widthClassName, widthStyle] = getWidth('full');
 */

var getWidth = function getWidth(width) {
  var _cx;

  var spaces = ['full', 'auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  var widthClassName = cx((_cx = {}, _cx[styles.wFull] = width === 'full', _cx[styles.wAuto] = width === 'auto', _cx[styles.w0] = width === 0, _cx[styles.w1] = width === 1, _cx[styles.w2] = width === 2, _cx[styles.w3] = width === 3, _cx[styles.w4] = width === 4, _cx[styles.w5] = width === 5, _cx[styles.w6] = width === 6, _cx[styles.w7] = width === 7, _cx[styles.w8] = width === 8, _cx[styles.w9] = width === 9, _cx[styles.w10] = width === 10, _cx[styles.w11] = width === 11, _cx));
  var widthStyle = createPropInlineStyle(width, spaces);
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [widthClassName, widthStyle];
};
/**
 * @typedef {"full" | "auto" | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | String} maxWidth
 *
 * @param maxWidth {maxWidth}
 * @returns - [className, style]
 *
 * @example
 * const [maxWidthClassName, maxWidthStyle] = getMaxWidth('full');
 */


export var getMaxWidth = function getMaxWidth(maxWidth) {
  var _cx2;

  var spaces = ['full', 'auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  var maxWidthClassName = cx((_cx2 = {}, _cx2[styles.mwFull] = maxWidth === 'full', _cx2[styles.mwAuto] = maxWidth === 'auto', _cx2[styles.mw0] = maxWidth === 0, _cx2[styles.mw1] = maxWidth === 1, _cx2[styles.mw2] = maxWidth === 2, _cx2[styles.mw3] = maxWidth === 3, _cx2[styles.mw4] = maxWidth === 4, _cx2[styles.mw5] = maxWidth === 5, _cx2[styles.mw6] = maxWidth === 6, _cx2[styles.mw7] = maxWidth === 7, _cx2[styles.mw8] = maxWidth === 8, _cx2[styles.mw9] = maxWidth === 9, _cx2[styles.mw10] = maxWidth === 10, _cx2[styles.mw11] = maxWidth === 11, _cx2));
  var maxWidthStyle = createPropInlineStyle(maxWidth, spaces);
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [maxWidthClassName, maxWidthStyle];
};
export default getWidth;